export const SIZES = {
  small: "818px",
  medium: "1288px",
  large: "1448px",
  xlarge: "1640px",
  page: "1200px",
  full: "unset",
  chartLoader: "1080px",
};
